import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuthorizeAndRedirectProps } from 'shared/hooks/useAuthorized';
import { IAuthorizedModal, ICalculatorMcfValues, ILandingState, TCalculatorMcfErrorsItem } from 'shared/types/features';
import { EFillApplicationStickyButtonType } from '../../containers/stickyButtons/FillApplicationButton/types';
import { IRow } from '../../repositories/mortgage-broker-calculator/entities/modal/Row';

export const initialState: ILandingState = {
  isModalOpen: false,
  isCianAuthorizedModalOpen: false,
  modalWindowContent: null,
  modalWindowRedirectParams: null,
  authorizedModal: {
    isOpen: false,
  },
  calculatorDefaultValues: undefined,
  calculatorValues: {} as ICalculatorMcfValues,
  calculatorErrors: [],
  activeMasterButton: null,
  offersLength: null,
  actionUrl: null,
  financePlatformEnabled: undefined,
  prefetchedOffersData: null,
  prefetchedOffersRequest: null,
  seoData: null,
  seoMarkedList: null,
  seoQuickLinks: null,
};

/* istanbul ignore next */
export const landingSlice = createSlice({
  initialState,
  name: 'landing',
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setCianAuthorizedModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCianAuthorizedModalOpen = action.payload;
    },
    setAuthorizedModal: (state, action: PayloadAction<IAuthorizedModal>) => {
      state.authorizedModal.isOpen = action.payload.isOpen;
      state.authorizedModal.pathForRedirect = action.payload.pathForRedirect;
      state.authorizedModal.bankName = action.payload.bankName;
      state.authorizedModal.typeForRedirect = action.payload.typeForRedirect;
      state.authorizedModal.targetElementForRedirect = action.payload.targetElementForRedirect;
    },
    setCalculatorValues: (state, action: PayloadAction<ICalculatorMcfValues>) => {
      state.calculatorValues = action.payload;
    },
    setCalculatorErrors: (state, action: PayloadAction<TCalculatorMcfErrorsItem[]>) => {
      state.calculatorErrors = action.payload;
    },
    resetCalculatorErrors: state => {
      state.calculatorErrors = [];
    },
    resetCalculatorValues: state => {
      state.calculatorValues = {} as ICalculatorMcfValues;
    },
    setModalContent: (state, action: PayloadAction<IRow[] | null>) => {
      state.modalWindowContent = action.payload;
    },
    setModalWindowOfferParams: (state, action: PayloadAction<IAuthorizeAndRedirectProps | null>) => {
      state.modalWindowRedirectParams = action.payload;
    },
    setActiveMasterButton: (state, action: PayloadAction<EFillApplicationStickyButtonType | 'showOffers' | null>) => {
      state.activeMasterButton = action.payload;
    },
    setOffersLength: (state, action: PayloadAction<number | null>) => {
      state.offersLength = action.payload;
    },
    setActionUrl: (state, action: PayloadAction<string>) => {
      state.actionUrl = action.payload;
    },
    setFinancePlatformEnabled: (state, action: PayloadAction<boolean | undefined>) => {
      state.financePlatformEnabled = action.payload;
    },
  },
});

export const {
  setModalOpen,
  setCianAuthorizedModalOpen,
  setAuthorizedModal,
  resetCalculatorValues,
  resetCalculatorErrors,
  setCalculatorErrors,
  setCalculatorValues,
  setModalContent,
  setModalWindowOfferParams,
  setActiveMasterButton,
  setOffersLength,
  setActionUrl,
  setFinancePlatformEnabled,
} = landingSlice.actions;
